import { isEqual } from "lodash";
export const concatSeriesFromDifferentRequestVisitor = () => (args) => {
    const visitables = [...args.visitable].sort((a, b) => ((a?.id || 1) > (b?.id || 0) ? 1 : -1));
    let newVisitable = visitables?.[0];
    visitables.forEach((v, index) => {
        if (index !== 0 && newVisitable?.series && v.series?.[0] && !newVisitable.series.find((x) => isEqual(x, v.series?.[0]))) {
            newVisitable = { ...newVisitable, series: [...newVisitable.series, v.series[0]] };
        }
    });
    args.visitable = [newVisitable];
};
